import { Col } from 'antd'
import { FC } from 'react'
import { formatNumber } from '../../../../util/formatNumber'
import { getColor } from '../../../../util/getColor'
import { Badges } from '../Badges'
import Styles from './HeaderBadges.module.scss'
import { BitazzaText } from '../../../../components'
import { SVGs } from '../../../../assets'

interface Props {
    data: LeaderBoardData[]
    selectedTime: string
    hallOfFameData?: hallOfFame[]
    isDesktop?: boolean
}

export const HeaderBadges: FC<Props> = ({
    data,
    hallOfFameData,
    isDesktop,
}) => {
    if (hallOfFameData && hallOfFameData.length) {
        return (
            <div className={Styles.container}>
                {data &&
                    data.map((badge, index) => {
                        const pnl: any = badge.pnl_percent
                        return (
                            <Col span={8} key={index}>
                                <Badges
                                    color={getColor(pnl, true)}
                                    type={'default'}
                                    rank={`${formatNumber(
                                        pnl,
                                        false,
                                        true,
                                        true,
                                        false
                                    )}%`}
                                    name={`@${badge.btz_id}`}
                                    highlighted={index === 1}
                                />
                            </Col>
                        )
                    })}
            </div>
        )
    }
    return (
        <div className={Styles.container}>
            {data &&
                data.map((badge, index) => {
                    return (
                        <Col
                            span={7}
                            key={index}
                            className={Styles.BadgesWrapper}
                            style={{
                                backgroundColor:
                                    index === 1 ? '#2D2D53' : '#13132C',
                                padding: isDesktop
                                    ? '8px'
                                    : index === 1
                                    ? '20px 16px'
                                    : '24px 16px',
                                borderRadius: '16px',
                                height: isDesktop
                                    ? index === 1
                                        ? '280px'
                                        : '240px'
                                    : index === 1
                                    ? '168px'
                                    : '124px',
                                width: isDesktop
                                    ? index === 1
                                        ? '280px'
                                        : '240px'
                                    : '100%',
                                flex: 'unset !important',
                                maxWidth: 'unset !important',
                                minWidth: isDesktop
                                    ? 'unset'
                                    : index === 1
                                    ? '132px'
                                    : 'unset',
                            }}
                        >
                            <Badges
                                color={getColor(badge.pnl_percent, true)}
                                type={'default'}
                                rank={`${formatNumber(
                                    badge.pnl_percent,
                                    false,
                                    true,
                                    true,
                                    false
                                )}%`}
                                name={`@${badge.btz_id}`}
                                highlighted={index === 1}
                                bigAvatar
                                isDesktop={isDesktop}
                            />
                            {index === 1 ? (
                                <div
                                    className={Styles.labelWrapper}
                                    style={{
                                        top: isDesktop ? '-32px' : '-44px',
                                    }}
                                >
                                    <div>
                                        {' '}
                                        <img
                                            src={SVGs.Crown}
                                            width={isDesktop ? 50 : 34}
                                            style={
                                                isDesktop
                                                    ? {
                                                          position: 'absolute',
                                                          top: '-40px',
                                                          marginInline: 'auto',
                                                          left: '0',
                                                          right: '0',
                                                      }
                                                    : undefined
                                            }
                                        />{' '}
                                        <div className={Styles.rankOne}>
                                            <BitazzaText
                                                content={'1'}
                                                bold
                                                format={
                                                    isDesktop ? 't32' : 't16'
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div
                                    className={Styles.labelWrapper}
                                    style={{
                                        top: isDesktop ? '-26px' : '-18px',
                                    }}
                                >
                                    <div>
                                        {' '}
                                        <div className={Styles.rankTwoThree}>
                                            <BitazzaText
                                                color="#FFFFFF"
                                                content={index === 0 ? 2 : 3}
                                                bold
                                                format={
                                                    isDesktop ? 't32' : 't16'
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Col>
                    )
                })}
        </div>
    )
}
